import { useEffect, useState } from 'react';
import { IconWifiOff } from '@tabler/icons-react';

/**
 * Slim, brand-styled "you're offline" banner. The app shell is precached by the
 * service worker, so the current view stays usable while offline — this just
 * surfaces the connection state instead of letting an API call fail silently or
 * show a browser error. Auto-clears when connectivity returns. Pinned above the
 * sticky TopBar (z-40); it adds no layout shift when hidden.
 */
export function OfflineNotice() {
  const [offline, setOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false,
  );

  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 inset-x-0 z-40 flex items-center justify-center gap-2 bg-navy px-4 pt-[max(0.375rem,env(safe-area-inset-top,0px))] pb-1.5 text-center text-xs font-medium text-cream"
    >
      <IconWifiOff size={14} className="shrink-0 text-gold-soft" />
      <span>You're offline — showing your last loaded view.</span>
    </div>
  );
}
